import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class MerchantService {
  GetMerchantDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI.post("/api/Merchant/GetMerchantDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateMerchantPayrollContact(input: any) {
    const _input = {
      merchantId: MerchantId(),
      payrollContactId: input.payrollContactId,
      ssoContactId: input.ssoContactId,
    };
    return service.peakRealTimeAPI
      .post("/api/Merchant/UpdateMerchantPayrollContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return service.peakRealTimeAPIForUser
      .get("/api/Merchant/GetMerchantListByUserId", { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser.get("/api/Merchant/GetSelectedMerchant", { params, headers }).then((res) => {
      return res;
    });
  }
  DoGetFavoriteMerchant() {
    const _input = {};
    return service.peakExportAPI.post("/api/Merchant/GetFavoriteMerchant", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/UpdateFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoDeleteFavoriteMerchant(merchantId: number) {
    const _input = {
      merchantId: merchantId,
    };
    return service.peakExportAPI
      .post("/api/Merchant/DeleteFavoriteMerchant", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new MerchantService();
